import React, {useContext, useEffect} from 'react';
import {Accordion, Loader, RowData} from '../../../../components';
import Layout from './Layout';
import {PageContext} from '../../../../helpers/context';
import {useEventDetails} from '../hooks/useEventsDetails';

function EventDetails() {
  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('easydetect');
  }, [setPageName]);

  const {isLoading, TRANSACTION_EVENT_INFO} = useEventDetails();
  return (
    <Layout>
      <div className=" xl:ml-4 xl:basis-[43.91%] mt-6 xl:mt-0 px-4 grow xl:grow-0 xl:p-8 pt-4 xl:pt-[36px] bg-white80 xl:bg-white">
        {isLoading ? (
          <Loader height={40} />
        ) : (
          <div className="flex flex-col gap-3 bg-brandBlueLight rounded p-3">
            <p className="p-3">Event Information</p>
            {[...TRANSACTION_EVENT_INFO]?.map(
              ({label, value}, index) =>
                value?.length > 0 && (
                  <Accordion
                    customTitle={
                      <h2 className="font-medium w-full capitalize">{label}</h2>
                    }
                    noChildPadding
                    customPadding=""
                    customClasses="bg-white p-3 pb-3"
                    background="bg-white"
                    isOpen={index !== 0}
                    key={index}
                  >
                    {value.map(data => (
                      <RowData
                        key={data.leftText}
                        leftText={data.leftText}
                        rightText={data.rightText}
                      />
                    ))}
                  </Accordion>
                ),
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default EventDetails;
